<template>
	<div>
		<div @click="expandMenu" class="flex items-center">
			<img
				v-if="menuExpanded"
				class="cursor-pointer"
				src="@/assets/img/admin-menu-abierto.svg"
				alt="menu-abierto"
			/>
			<img
				v-if="!menuExpanded"
				class="cursor-pointer"
				src="@/assets/img/admin-menu.svg"
				alt="menu"
			/>
			<span class="ml-2 uppercase font-medium hidden md:block">{{
				itemSelected
			}}</span>
		</div>
		<div class="flex flex-col mt-4 mr-8" v-if="menuExpanded">
			<router-link
				@click.native="itemSelected = $t('profile')"
				class="
					text-primary
					bg-customLigthGrey
					flex
					items-center
					no-underline
					p-2
				"
				to="/profile"
			>
				<img class="mr-2" src="@/assets/img/admin-noticias.svg" alt="Perfil" />
				<span class="hidden md:block">{{ $t('profile') }}</span>
			</router-link>
			<router-link
				@click.native="itemSelected = $t('password')"
				class="
					text-primary
					bg-customLigthGrey
					flex
					items-center
					no-underline
					p-2
				"
				to="/profile/change_password"
			>
				<img
					class="mr-2"
					src="@/assets/img/admin-permisos.svg"
					alt="Password"
				/>
				<span class="hidden md:block">{{ $t('password') }}</span>
			</router-link>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	data() {
		return {
			itemSelected: '',
			menuExpanded: true
		}
	},
	computed: {
		...mapGetters({
			user: 'login/user'
		})
	},
	created() {
		// this.onLoadSections();
		this.$store.dispatch('adminMenu', this.menuExpanded)
	},
	methods: {
		expandMenu() {
			this.menuExpanded = !this.menuExpanded
			this.$store.dispatch('adminMenu', this.menuExpanded)
		}
	}
}
</script>

<style scoped>
a:hover span,
a.router-link-exact-active span {
	color: #68ace1;
}
a:hover img,
a.router-link-exact-active img {
	filter: invert(0.4) sepia(1) saturate(4) hue-rotate(180.6deg) brightness(0.9);
	transition-duration: 0.1s;
}
div a:hover span,
div a.router-link-exact-active span {
	color: #68ace1;
}
div a:hover img,
div a.router-link-exact-active img {
	filter: invert(0.3) sepia(1) saturate(20) hue-rotate(181.6deg)
		brightness(0.83);
	transition-duration: 0.1s;
}
</style>
